import React, { useState } from "react";

import { BsArrowLeft } from "react-icons/bs";
import ClipLoader from "react-spinners/ClipLoader";
import OtpPin from "../../../components/OtpPin";
import { formatAmount } from "../../../utils/formatTime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import GetRates from "../../../components/utils/GetRates";
import { API } from "../../../constants/api";
import useAuthAxios from "../../../utils/baseAxios";
import { errorMessage } from "../../../utils/errorMessage";
import { useUser } from "../../../context/user-context";
import { invalidateActivityQueries } from "../../../utils/invalidateActivityQueries";

const WithdrawPreview = ({
  setOpenWithdrawBank,
  setOpenWithdrawPreview,
  setOpenWithdrawSuccess,
  amount,
  coin,
  usdAmount,
}: any) => {
  const queryClient = useQueryClient();
  const { refetch } = useUser();
  const [addPin, setAddPin] = useState<boolean>(false);
  const [otp, setOtp] = useState<string>("");

  const axiosInstance = useAuthAxios();
  const nairaCoinRate = GetRates(coin?.abbr?.toLowerCase());

  const sellCrypto = async ({ asset, amount, pin }: any) => {
    const response = await axiosInstance.post(API.sellCrypto, {
      asset,
      amount,
      pin,
    });
    return response.data;
  };

  const completeSellCrypto = useMutation({
    mutationFn: sellCrypto,
    onSuccess: (r) => {
      toast.success(r.message);
      invalidateActivityQueries(queryClient);
      queryClient.invalidateQueries({ queryKey: ["userDetails"] });
      setTimeout(() => {
        setOpenWithdrawPreview(false);
        setOpenWithdrawSuccess(true);
        refetch();
      }, 2000);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });
  const coinAmountInUsdt = Number(usdAmount);

  const totalNaira = coinAmountInUsdt * (nairaCoinRate || 0);

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenWithdrawPreview(false);
              setOpenWithdrawBank(true);
            }}
            className="flex items-center gap-2 "
          >
            <BsArrowLeft className="dark:text-[#D8D8D8] text-gray-800 text-[12px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Preview Withdraw
          </h4>
        </div>
        {addPin ? (
          <div className="mt-12">
            <h4 className="text-gray-900 text-center dark:text-gray-100 font-sora mb-4 font-semibold text-[20px]">
              Enter transaction PIN
            </h4>
            <OtpPin otp={otp} input={4} setOtp={setOtp} />
            <button
              onClick={() => {
                const data = {
                  asset: coin.abbr,
                  amount: Number(amount),
                  pin: otp,
                };
                // console.log(data);
                completeSellCrypto.mutate(data);
              }}
              disabled={otp.length !== 4}
              className={
                otp.length !== 4
                  ? "mt-44 bg-gray-400 flex justify-center items-center text-gray-200 font-medium w-full h-[52px] rounded-xl"
                  : "mt-44 bg-secondary_button flex justify-center items-center text-white font-medium w-full h-[52px] rounded-xl"
              }
            >
              {completeSellCrypto.isPending ? (
                <ClipLoader color="#ffffff" size={20} />
              ) : (
                "Proceed"
              )}
            </button>
          </div>
        ) : (
          <div className="w-full mt-8">
            <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
              <h4 className="text-secondary_button text-[13px] font-bold">
                Coin to withdraw
              </h4>
              <h4 className=" mt-2 text-[20px] text-[#13181B] dark:text-gray-100 uppercase font-sora font-bold">
                {coin.name} {coin.abbr}
              </h4>
            </div>
            <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
              <h4 className="text-secondary_button text-[13px] font-bold">
                Amount
              </h4>
              <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100">
                {formatAmount(amount)} ({coin.abbr})
              </h4>
            </div>
            <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
              <h4 className="text-secondary_button text-[13px] font-bold">
                Amount in USD
              </h4>
              <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100">
                {formatAmount(usdAmount)} (USD)
              </h4>
            </div>
            <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
              <h4 className="text-secondary_button text-[13px] font-bold">
                Rate
              </h4>
              <h4 className=" mt-2 text-[16px] text-[#BE6B0A]">
                1$ ~ ₦{nairaCoinRate ? nairaCoinRate : "--"}
              </h4>
            </div>

            <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
              <h4 className="text-secondary_button text-[13px] font-bold">
                Total amount to recieve
              </h4>
              <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100">
                ₦{formatAmount(totalNaira)}
              </h4>
            </div>
            <button
              onClick={() => {
                // setOpenPreview(false);
                // setOpenSellPending(true);
                if (coinAmountInUsdt < 10) {
                  toast.error(
                    `Minimum sell amount is $10 worth of ${coin.name}`
                  );
                  return;
                }
                setAddPin(true);
              }}
              className="mt-12 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[52px] w-full rounded-xl"
            >
              Sell {coin.abbr}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default WithdrawPreview;
